import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "protocol-page",
  "element-loading-text": "加载中...",
  "element-loading-background": "rgba(255, 255, 255, 0.8)"
}
const _hoisted_2 = { class: "info-hero" }
const _hoisted_3 = { class: "hero-main" }
const _hoisted_4 = { class: "hero-avatar" }
const _hoisted_5 = { class: "hero-text" }
const _hoisted_6 = {
  key: 0,
  class: "hero-subtitle"
}
const _hoisted_7 = { class: "stat-strip" }
const _hoisted_8 = { class: "stat-mini stat-total" }
const _hoisted_9 = { class: "stat-mini-icon" }
const _hoisted_10 = { class: "stat-mini-body" }
const _hoisted_11 = { class: "stat-mini-value" }
const _hoisted_12 = { class: "stat-mini stat-completion" }
const _hoisted_13 = { class: "stat-mini-icon" }
const _hoisted_14 = { class: "stat-mini-body" }
const _hoisted_15 = { class: "stat-mini-value" }
const _hoisted_16 = { class: "stat-mini-bar" }
const _hoisted_17 = { class: "stat-mini stat-groups" }
const _hoisted_18 = { class: "stat-mini-icon" }
const _hoisted_19 = { class: "stat-mini-body" }
const _hoisted_20 = { class: "stat-mini-value" }
const _hoisted_21 = { class: "stat-mini stat-dirty" }
const _hoisted_22 = { class: "stat-mini-icon" }
const _hoisted_23 = { class: "stat-mini-body" }
const _hoisted_24 = { class: "stat-mini-value" }
const _hoisted_25 = { class: "main-content" }
const _hoisted_26 = { class: "toolbar-card" }
const _hoisted_27 = { class: "toolbar-search" }
const _hoisted_28 = { class: "toolbar-actions" }
const _hoisted_29 = {
  key: 0,
  class: "dirty-badge"
}
const _hoisted_30 = { class: "group-card group-card-base" }
const _hoisted_31 = { class: "group-header" }
const _hoisted_32 = { class: "group-icon-base" }
const _hoisted_33 = { class: "group-info" }
const _hoisted_34 = { class: "group-title-row" }
const _hoisted_35 = { class: "group-card group-card-warning" }
const _hoisted_36 = { class: "group-header" }
const _hoisted_37 = { class: "group-icon-warning" }
const _hoisted_38 = { class: "group-info" }
const _hoisted_39 = { class: "group-title-row" }
const _hoisted_40 = { class: "group-card group-card-success" }
const _hoisted_41 = { class: "group-header" }
const _hoisted_42 = { class: "group-icon-success" }
const _hoisted_43 = { class: "group-info" }
const _hoisted_44 = { class: "group-title-row" }

import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { ElMessage, ElMessageBox } from "element-plus";
import type { UploadFile } from "element-plus";
import {
  DataLine,
  Ship,
  Histogram,
  MagicStick,
  Files,
  Refresh,
  Upload,
  Download,
  Check,
  Promotion,
  Plus,
  Delete,
  RefreshLeft,
  Search,
  Filter,
  InfoFilled,
  CopyDocument,
  ArrowLeft,
} from "@element-plus/icons-vue";
import {
  getProtocolListApi,
  saveProtocolApi,
  deleteProtocolItemApi,
  pushProtocolApi,
  type ShipProtocolItem,
} from "@/api/operation/shipProtocolTemplateApi";
import { fetchOrganizationShipListApi } from "@/api/productApi";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { loadProtocolText } from "@/composables/useProtocolText";
import {
  translateSrcToZh,
  translateSrcToEn,
  loadTranslations,
} from "@/composables/useTranslation";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShipProtocolTemplateView',
  setup(__props) {

const route = useRoute();
const selectedShipId = ref<string>((route.query.shipId as string) || "");
// 船舶名优先从路由 query 中取（跳转即带），shipList 异步加载后再覆盖一次
const cachedShipName = (route.query.shipName as string) || "";
const tableData = ref<ShipProtocolItem[]>([]);
const originalData = ref<ShipProtocolItem[]>([]);
// 全局默认模板（dataId -> 默认项），船舶视图用于判定"默认数据"及恢复基准
const defaultItemsMap = ref<Map<number, ShipProtocolItem>>(new Map());
const shipList = ref<{ id: string; name: string }[]>([]);
const pushLoading = ref(false);
const loading = ref(false);
const searchKeyword = ref<string>("");

const currentShipName = computed(() => {
  if (!selectedShipId.value) return "全局模板";
  const ship = shipList.value.find((s) => s.id === selectedShipId.value);
  return ship?.name || cachedShipName || "未知船舶";
});

const getGroupData = (min: number, max: number): ShipProtocolItem[] => {
  return tableData.value.filter(
    (item) => item.dataId >= min && item.dataId <= max
  );
};

const getFilteredGroupData = (min: number, max: number): ShipProtocolItem[] => {
  const data = tableData.value.filter((item) => {
    // 已保存项：用 originalData 中的原始 dataId 判断归属组
    if (item.id) {
      const orig = originalData.value.find((o) => o.id === item.id);
      const origDataId = orig ? orig.dataId : item.dataId;
      return origDataId >= min && origDataId <= max;
    }
    // 新增项：用 sortOrder 判断归属组
    if (item.sortOrder === min) return true;
    // 导入项（id 为空但 sortOrder 不是 min）：按 dataId 判断
    if (item.dataId >= min && item.dataId <= max) return true;
    return false;
  });
  if (!searchKeyword.value) return data;
  const kw = searchKeyword.value.toLowerCase();
  return data.filter(
    (item) =>
      (item.fieldName && item.fieldName.toLowerCase().includes(kw)) ||
      (item.dataName && item.dataName.toLowerCase().includes(kw)) ||
      (item.dataFormat && item.dataFormat.toLowerCase().includes(kw))
  );
};

const isValidFieldName = (name: string): boolean => {
  if (!name) return true;
  return /^[a-z][a-zA-Z0-9]*$/.test(name);
};

/**
 * 字段简写（shortCode）格式校验：允许为空（保存时后端按 dataId 推导），
 * 非空时须为小写字母开头 + 小写字母/数字（如 g1/b2/c10/d30）
 */
const isValidShortCode = (code: string): boolean => {
  if (!code) return true;
  return /^[a-z][a-z0-9]*$/.test(code);
};

/**
 * 按数据序号推导字段简写默认值（与后端 deriveShortCode 规则一致）：
 * 1-9 -> g{n}，20 -> m1，21-26 -> b{n-20}，101-111 -> c{n-100}，其他 -> d{n}
 * 新增行时预填，用户可改；保存时后端同样规则兜底
 */
const deriveShortCode = (dataId: number): string => {
  if (dataId >= 1 && dataId <= 9) return `g${dataId}`;
  if (dataId === 20) return "m1";
  if (dataId >= 21 && dataId <= 26) return `b${dataId - 20}`;
  if (dataId >= 101 && dataId <= 111) return `c${dataId - 100}`;
  return `d${dataId}`;
};

const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    ElMessage.success(`已复制: ${text}`);
  } catch {
    ElMessage.warning("复制失败，请手动复制");
  }
};

const groupsCompleted = computed(() => {
  let count = 0;
  if (getGroupData(1, 9).length > 0) count++;
  if (getGroupData(20, 26).length > 0) count++;
  if (getGroupData(100, 999).length > 0) count++;
  return count;
});

const completionRate = computed(() => {
  const total = 27; // 9+7+11
  return Math.min(tableData.value.length / total, 1);
});

const isDirty = computed(() => dirtyCount.value > 0);
const dirtyCount = computed(() => {
  return tableData.value.filter((item) => isItemDirty(item)).length;
});

const isItemDirty = (item: ShipProtocolItem): boolean => {
  if (!item.id) return true;
  const orig = originalData.value.find((o) => o.id === item.id);
  if (!orig) return true;
  return (
    orig.dataId !== item.dataId ||
    orig.fieldName !== item.fieldName ||
    orig.shortCode !== item.shortCode ||
    orig.dataName !== item.dataName ||
    orig.dataFormat !== item.dataFormat ||
    orig.dataSource !== item.dataSource ||
    orig.description !== item.description
  );
};

/**
 * 检查单项中某字段是否被修改过
 * @param item 当前项
 * @param field 字段名
 * @param currentValue 当前输入框的值
 * @returns 是否被修改
 */
const isFieldDirty = (
  item: ShipProtocolItem,
  field: keyof ShipProtocolItem,
  currentValue: any
): boolean => {
  if (!item.id) {
    // 新增项：只要该字段有值就标记为已修改
    return (
      currentValue !== "" && currentValue !== null && currentValue !== undefined
    );
  }
  const orig = originalData.value.find((o) => o.id === item.id);
  if (!orig) return true;
  return (orig as any)[field] !== currentValue;
};

const loadShipList = async () => {
  const res = await fetchOrganizationShipListApi("");
  if (res) {
    shipList.value = res.map((s: any) => ({ id: s.id, name: s.name }));
  }
};

const loadData = async () => {
  loading.value = true;
  try {
    // 翻译缓存就绪再做英文->中文转换（幂等共享；登录后首次进入时 App/登录页阶段的
    // 加载可能因 401 失败导致缓存为空，此处在每个 loadData 入口兜底重试，避免显示英文）
    await loadTranslations();
    // 船舶视图：同时加载全局默认模板，用于判定"默认数据"与恢复基准
    const [res, defaults] = await Promise.all([
      getProtocolListApi(selectedShipId.value || undefined),
      selectedShipId.value ? getProtocolListApi() : Promise.resolve(null),
    ]);
    defaultItemsMap.value = new Map((defaults || []).map((d) => [d.dataId, d]));
    if (res) {
      // 页面展示/编辑统一中文设备名：库存英文 src -> 前端翻译缓存转中文
      // （保存提交前 translateSrcToEn 转回英文，库内 data_source 始终为英文）
      res.forEach((item: ShipProtocolItem) => {
        item.dataSource = translateSrcToZh(item.dataSource);
      });
      tableData.value = res;
      originalData.value = JSON.parse(JSON.stringify(res));
    } else {
      tableData.value = [];
      originalData.value = [];
    }
  } finally {
    loading.value = false;
  }
};

/**
 * 判断某行是否为默认模板数据（船舶视图下，该数据序号存在于全局默认模板中）
 * 默认数据不可删除，只能"恢复默认"
 */
const isDefaultData = (row: ShipProtocolItem): boolean => {
  // 未保存的新增行（含 Excel 导入的新增行）一律按"新增数据"处理，可删除、不可恢复：
  // 即使用户把数据序号改成与默认模板相同的值，也不能变成"恢复默认"，
  // 否则会出现两条同序号行、恢复逻辑错乱
  if (!row.id) return false;
  return !!selectedShipId.value && defaultItemsMap.value.has(row.dataId);
};

/**
 * 判断某行是否为已保存的船舶专属副本（覆盖了默认模板的修改）
 */
const isShipOverride = (row: ShipProtocolItem): boolean => {
  return !!row.id && !!row.shipId && row.shipId === selectedShipId.value;
};

/**
 * 默认数据是否可恢复：有未保存修改，或已保存为船舶专属副本
 */
const canRestore = (row: ShipProtocolItem): boolean => {
  return isItemDirty(row) || isShipOverride(row);
};

/**
 * 恢复默认数据（立即生效，无需再点保存）：
 * - 已保存的专属副本：弹窗确认后删除数据库中的副本，并重载列表
 * - 未保存的修改：纯本地恢复为默认模板值（不弹窗、不请求），同步基准快照（清除脏标记），
 *   同时保留页面上其他行的未保存修改
 */
const handleRestore = async (row: ShipProtocolItem) => {
  // 防御：只有当前行的 shipId 等于当前船舶 ID（即确为已保存的船舶专属副本）才允许调删除接口，
  // 避免状态错乱时误删默认模板数据
  const isOverride =
    !!row.id &&
    !!row.shipId &&
    row.shipId === selectedShipId.value &&
    !!selectedShipId.value;
  if (isOverride) {
    // 已保存的专属副本：删除会影响数据库，需弹窗确认
    const displayName = row.dataName || row.dataId;
    try {
      await ElMessageBox.confirm(
        `确认将「${displayName}」恢复为默认数据？该船舶的专属修改将被删除。`,
        "恢复确认",
        {
          type: "warning",
          confirmButtonText: "确认恢复",
          cancelButtonText: "取消",
        }
      );
    } catch {
      // 用户取消
      return;
    }
    const res = await deleteProtocolItemApi(row.id);
    if (!res) {
      ElMessage.error("恢复失败");
      return;
    }
  }
  const source = defaultItemsMap.value.get(row.dataId);
  if (source) {
    const copy = JSON.parse(JSON.stringify(source));
    // 默认模板库存英文 src，恢复到页面时同步转中文（保持展示/编辑态一致）
    copy.dataSource = translateSrcToZh(copy.dataSource);
    Object.assign(row, copy);
    // 同步基准快照（按 dataId 定位），保证 isItemDirty 判定正确、恢复按钮随之消失；
    // 找不到基准时补插一份，避免行被持续误判为"有修改"
    const origIndex = originalData.value.findIndex(
      (o) => o.dataId === row.dataId
    );
    if (origIndex > -1) {
      originalData.value[origIndex] = JSON.parse(JSON.stringify(copy));
    } else {
      originalData.value.push(JSON.parse(JSON.stringify(copy)));
    }
  }
  ElMessage.success("已恢复为默认数据");
  if (isOverride) {
    // 已保存场景：数据库已变更，重新加载列表由后端合并结果重建行状态，
    // 确保恢复按钮必然消失（本地对象同步在任何异常路径下都可能残留按钮）
    await loadData();
    // 协议 TEXT 枚举可能已变更，刷新前端缓存
    loadProtocolText();
  }
};

watch(selectedShipId, () => {
  loadData();
});

const handleSaveAll = async () => {
  if (!isDirty.value) {
    ElMessage.info("没有修改需要保存");
    return;
  }
  // 保存前校验：数据序号不能为空、不能重复（后端主键由序号生成，重复会导致保存失败）
  const seenIds = new Set<number>();
  const dupIds = new Set<number>();
  let hasEmptyId = false;
  for (const item of tableData.value) {
    if (item.dataId == null) {
      hasEmptyId = true;
      continue;
    }
    if (seenIds.has(item.dataId)) dupIds.add(item.dataId);
    else seenIds.add(item.dataId);
  }
  if (hasEmptyId) {
    ElMessage.error("存在未填写数据序号的行，请补全后再保存");
    return;
  }
  if (dupIds.size > 0) {
    const sortedIds = [...dupIds].sort((a, b) => a - b).join("、");
    ElMessage.error(`数据序号重复：${sortedIds}，请修改后再保存`);
    return;
  }
  // 保存前校验：字段简写格式（空=后端推导；非空须小写字母开头）与重复
  // （简写是 [2,5] 下发 / [3,2] 上报的配对键，重复会导致解析歧义，后端同样校验）
  const badCodes = tableData.value.filter(
    (item) => !isValidShortCode(item.shortCode || "")
  );
  if (badCodes.length > 0) {
    const names = badCodes.map((i) => i.fieldName || i.dataId).join("、");
    ElMessage.error(
      `字段简写格式不正确（须小写字母开头，如 g1/b2/c3）：${names}`
    );
    return;
  }
  const seenCodes = new Set<string>();
  const dupCodes = new Set<string>();
  for (const item of tableData.value) {
    const code = (item.shortCode || "").trim();
    if (!code) continue; // 空值由后端按 dataId 推导（dataId 已查重）
    if (seenCodes.has(code)) dupCodes.add(code);
    else seenCodes.add(code);
  }
  if (dupCodes.size > 0) {
    ElMessage.error(
      `字段简写重复：${[...dupCodes].sort().join("、")}，请修改后再保存`
    );
    return;
  }
  const res = await saveProtocolApi(
    selectedShipId.value || null,
    // 提交前中文设备名转英文（页面编辑态为中文）：
    // 翻译缓存未命中的中文原样提交，后端保存入口 normalizeSrc 兜底翻译
    tableData.value.map((item) => ({
      ...item,
      dataSource: translateSrcToEn(item.dataSource),
    }))
  );
  if (res) {
    ElMessage.success("保存成功");
    // 后端保存时可能新翻译设备名并入库，强制刷新翻译缓存再重载
    // （否则 loadData 的英文->中文转换使用旧缓存，新设备名会显示英文）
    await loadTranslations(true);
    loadData();
    // 协议 TEXT 枚举可能已变更，刷新前端缓存
    loadProtocolText();
  } else {
    ElMessage.error("保存失败");
  }
};

const handleDelete = async (row: ShipProtocolItem) => {
  // 安全防线：船舶视图下的默认模板数据禁止删除（只能"恢复默认"），
  // 防止任何状态错乱导致默认数据被误删
  if (isDefaultData(row)) {
    ElMessage.warning("默认数据不可删除，如需撤销修改请使用「恢复默认」");
    return;
  }
  // 未保存的新增行：尚未入库，直接从列表移除，无需确认
  if (!row.id) {
    const index = tableData.value.findIndex((item) => item === row);
    if (index > -1) {
      tableData.value.splice(index, 1);
    }
    ElMessage.success("已删除");
    return;
  }
  try {
    await ElMessageBox.confirm(
      `确认删除「${row.dataName || row.dataId}」？此操作不可撤销。`,
      "删除确认",
      {
        type: "warning",
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
      }
    );
    const res = await deleteProtocolItemApi(row.id);
    if (!res) {
      ElMessage.error("删除失败");
      return;
    }
    const index = tableData.value.findIndex((item) => item === row);
    if (index > -1) {
      tableData.value.splice(index, 1);
      originalData.value = originalData.value.filter((o) => o.id !== row.id);
    }
    ElMessage.success("删除成功");
    // 协议 TEXT 枚举可能已变更，刷新前端缓存
    loadProtocolText();
  } catch {
    // 用户取消
  }
};

const handleAddItem = (min: number, max: number) => {
  // 已被占用的数据序号集合（全局统计，含此前新增或超出组范围的行，如第 1 组的 10）
  const usedIds = new Set(
    tableData.value
      .map((item) => item.dataId)
      .filter((id): id is number => id != null)
  );
  // 从组起始序号起取第一个未占用的序号
  // （旧逻辑按"组内最大序号+1"取号，组范围外（>max）的行会被过滤条件漏算，
  //   连续两次新增会拿到同一序号，保存时主键冲突 Duplicate entry）
  let newDataId = min;
  while (usedIds.has(newDataId)) newDataId++;
  tableData.value.push({
    id: "",
    shipId: selectedShipId.value || null,
    dataId: newDataId,
    fieldName: "",
    // 预填推导短码（用户可改，保存时空值由后端同规则兜底）
    shortCode: deriveShortCode(newDataId),
    dataName: "",
    dataFormat: "",
    dataSource: "",
    description: "",
    chTable: "",
    chColumn: "",
    // sortOrder 固定为 min，确保归入正确的组
    sortOrder: min,
  });
  ElMessage.success(
    `已新增数据项（序号 ${newDataId}），请填写字段信息后点击「保存全部」`
  );
};

const handlePush = async () => {
  if (!selectedShipId.value) {
    ElMessage.warning("请先选择船舶");
    return;
  }
  try {
    await ElMessageBox.confirm("确认推送协议到终端？", "推送确认", {
      type: "warning",
      confirmButtonText: "确认",
      cancelButtonText: "取消",
    });
    pushLoading.value = true;
    const res = await pushProtocolApi(selectedShipId.value);
    if (res) {
      if (res.success) {
        ElMessage.success(res.message || "推送成功");
      } else {
        ElMessage.error(res.message || "推送失败");
      }
    } else {
      ElMessage.error("推送失败");
    }
  } catch {
    // 用户取消
  } finally {
    pushLoading.value = false;
  }
};

const handleImportExcel = async (file: UploadFile) => {
  if (!file.raw) return;
  try {
    // 翻译缓存就绪（下方解析时 dataSource 英->中转换依赖缓存；幂等共享，
    // App 阶段加载 401 失败时此处重试兜底）
    await loadTranslations();
    const buffer = await file.raw.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);
    const worksheet = workbook.getWorksheet(1);
    if (!worksheet) {
      ElMessage.error("Excel 中未找到工作表");
      return;
    }
    const rows: ShipProtocolItem[] = [];
    // 全部列标题（含新模板的"字段简写"列）
    const headerTexts = [
      "数据序号",
      "字段名称",
      "字段简写",
      "数据名称",
      "数据格式",
      "数据来源",
      "数据说明",
    ];
    // 定义分组标题（用于跳过）
    const groupTitles = ["船舶基础数据", "电池运营数据", "船舶运营数据"];
    // 列标题 -> 列索引映射：遇到表头行动态重建，兼容无"字段简写"列的旧模板
    let colMap: Record<string, number> = {};

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return; // 跳过第1行（分组标题或表头）
      const values = row.values as any[];
      // ExcelJS 的 values 数组从索引 1 开始
      const cellA = values[1]?.toString()?.trim() || "";

      // 跳过空行
      if (!cellA) return;
      // 表头行：重建列映射（每组数据前各有一行表头）
      if (cellA === "数据序号") {
        colMap = {};
        values.forEach((v, idx) => {
          const t = v?.toString()?.trim();
          if (t && headerTexts.includes(t)) colMap[t] = idx;
        });
        return;
      }
      // 跳过其余表头文本行与分组标题行（历史结构防御）
      if (headerTexts.includes(cellA) || groupTitles.includes(cellA)) return;

      const dataId = parseInt(cellA, 10);
      if (isNaN(dataId)) return;

      // 按列映射取值；旧模板无"字段简写"列时取空串（保存时后端按 dataId 推导）
      const col = (title: string): string =>
        colMap[title] != null
          ? (values[colMap[title]]?.toString() || "").trim()
          : "";

      rows.push({
        id: "",
        shipId: selectedShipId.value || null,
        dataId,
        fieldName: col("字段名称"),
        shortCode: col("字段简写"),
        dataName: col("数据名称"),
        dataFormat: col("数据格式"),
        // 数据来源统一中文态进表格（Excel 可能填中文或英文，英文经翻译转中文；
        // 保存提交前 translateSrcToEn 统一转英文入库，导出亦转中文）
        dataSource: translateSrcToZh(col("数据来源")),
        description: col("数据说明"),
        chTable: "",
        chColumn: "",
        sortOrder: dataId,
      });
    });

    if (rows.length === 0) {
      ElMessage.warning("未解析到有效数据");
      return;
    }

    // 校验数据序号重复（保存时后端按序号生成主键，重复必然失败，提前在导入时拦截）
    const seenIds = new Set<number>();
    const dupIds = new Set<number>();
    for (const r of rows) {
      if (seenIds.has(r.dataId)) dupIds.add(r.dataId);
      else seenIds.add(r.dataId);
    }
    if (dupIds.size > 0) {
      ElMessage.error(
        `Excel 中数据序号重复：${[...dupIds]
          .sort((a, b) => a - b)
          .join("、")}，请修正后重新导入`
      );
      return;
    }

    // 请求数据库最新数据，与 Excel 数据对比
    const dbRes = await getProtocolListApi(selectedShipId.value || undefined);
    if (dbRes && dbRes.length > 0) {
      // 库存英文 src 转中文（Excel 侧已在解析时统一中文态，中文 vs 中文可比；
      // 否则任一侧为英文都会恒不等，导入对比会误判为"已修改"）
      dbRes.forEach((item: ShipProtocolItem) => {
        item.dataSource = translateSrcToZh(item.dataSource);
      });
      // 把 Excel 数据和数据库数据按 dataId 匹配
      // 匹配到：完整继承数据库行的 id/shipId/chTable/chColumn/sortOrder ——
      //   - id/shipId 决定"默认数据 vs 船舶专属副本"的判定（影响恢复/删除按钮）
      //   - chTable/chColumn 是 ClickHouse 取数映射，不继承会在保存时被空串覆盖，导致 CCS 报表取数失效
      // 未匹配到（新增）：id 为空，标记为新增
      for (const excelRow of rows) {
        const dbItem = dbRes.find((d) => d.dataId === excelRow.dataId);
        if (dbItem) {
          excelRow.id = dbItem.id;
          excelRow.shipId = dbItem.shipId;
          excelRow.chTable = dbItem.chTable || "";
          excelRow.chColumn = dbItem.chColumn || "";
          excelRow.sortOrder = dbItem.sortOrder ?? dbItem.dataId;
        }
      }
      // originalData 设为数据库数据，这样只有真正改了的字段才会高亮
      originalData.value = JSON.parse(JSON.stringify(dbRes));
    } else {
      // 数据库没有数据，全部视为新增
      originalData.value = JSON.parse(JSON.stringify(rows));
    }

    tableData.value = rows;

    // 统计差异
    const dirtyCount = rows.filter((item) => isItemDirty(item)).length;
    const totalCount = rows.length;
    if (dirtyCount === 0) {
      ElMessage.success(
        `导入成功，共 ${totalCount} 条数据，与数据库一致，无需保存`
      );
    } else {
      ElMessage.success(
        `导入成功，共 ${totalCount} 条数据，其中 ${dirtyCount} 条有修改`
      );
    }
  } catch (e: any) {
    const msg = e.message || "";
    if (msg.includes("zip") || msg.includes("central directory")) {
      ElMessage.error(
        "导入失败：文件格式不支持。请确保使用 .xlsx 格式（不要用 .xls 或其他格式另存）"
      );
    } else {
      ElMessage.error("导入失败: " + msg);
    }
  }
};

const handleExportExcel = () => {
  if (tableData.value.length === 0) {
    ElMessage.warning("没有数据可导出");
    return;
  }
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("协议数据");
  const groups = [
    { name: "船舶基础数据", min: 1, max: 19, color: "FF409EFF" },
    { name: "电池运营数据", min: 20, max: 99, color: "FFE6A23C" },
    { name: "船舶运营数据", min: 100, max: 999, color: "FF67C23A" },
  ];
  const columns = [
    { key: "dataId", header: "数据序号", width: 10 },
    { key: "fieldName", header: "字段名称", width: 25 },
    { key: "shortCode", header: "字段简写", width: 10 },
    { key: "dataName", header: "数据名称", width: 25 },
    { key: "dataFormat", header: "数据格式", width: 35 },
    { key: "dataSource", header: "数据来源", width: 25 },
    { key: "description", header: "数据说明", width: 35 },
  ];
  worksheet.columns = columns;
  let currentRow = 1;
  const centerStyle = {
    vertical: "middle" as const,
    horizontal: "center" as const,
    wrapText: true,
  };
  for (const group of groups) {
    const groupData = tableData.value.filter(
      (item) => item.dataId >= group.min && item.dataId <= group.max
    );
    if (groupData.length === 0) continue;
    const groupRow = worksheet.addRow({
      dataId: group.name,
      fieldName: "",
      shortCode: "",
      dataName: "",
      dataFormat: "",
      dataSource: "",
      description: "",
    });
    worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
    groupRow.eachCell((cell) => {
      cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
      cell.alignment = centerStyle;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: group.color },
      };
    });
    groupRow.height = 24;
    currentRow++;
    const headerRow = worksheet.addRow(
      columns.reduce((acc, col) => {
        acc[col.key] = col.header;
        return acc;
      }, {} as any)
    );
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = centerStyle;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFF5F7FA" },
      };
    });
    currentRow++;
    for (const item of groupData) {
      const row = worksheet.addRow({
        dataId: item.dataId,
        fieldName: item.fieldName || "",
        shortCode: item.shortCode || "",
        dataName: item.dataName || "",
        dataFormat: item.dataFormat || "",
        // 数据来源导出统一中文（表格值可能仍为英文——缓存未命中等场景，兜底转换；
        // 已是中文则 translateSrcToZh 原样返回）
        dataSource: translateSrcToZh(item.dataSource) || "",
        description: item.description || "",
      });
      row.eachCell((cell) => {
        cell.alignment = centerStyle;
      });
      currentRow++;
    }
    worksheet.addRow({});
    currentRow++;
  }
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const date = new Date().toISOString().slice(0, 10);
    saveAs(blob, `船舶运营协议_${date}.xlsx`);
    ElMessage.success("导出成功");
  });
};

onMounted(async () => {
  // 等翻译缓存就绪再 loadData（src 英->中转换依赖缓存；与 App 启动加载共享同一次请求）
  await loadTranslations();
  // 先加载船舶列表，让船舶名计算属性可以正确解析
  await loadShipList();
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Cellphone = _resolveComponent("Cellphone")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Lightning = _resolveComponent("Lightning")!
  const _component_TrendCharts = _resolveComponent("TrendCharts")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"hero-bg\" data-v-071f1253><svg viewBox=\"0 0 800 200\" preserveAspectRatio=\"none\" class=\"hero-svg\" data-v-071f1253><circle cx=\"100\" cy=\"100\" r=\"180\" fill=\"rgba(255,255,255,0.05)\" data-v-071f1253></circle><circle cx=\"650\" cy=\"40\" r=\"150\" fill=\"rgba(8,145,178,0.22)\" data-v-071f1253></circle><circle cx=\"780\" cy=\"180\" r=\"90\" fill=\"rgba(255,255,255,0.06)\" data-v-071f1253></circle><path d=\"M 0 150 Q 200 100 400 130 T 800 110\" stroke=\"rgba(255,255,255,0.10)\" stroke-width=\"1\" fill=\"none\" data-v-071f1253></path><path d=\"M 0 170 Q 220 140 420 160 T 800 140\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"1\" fill=\"none\" data-v-071f1253></path></svg></div>", 1)),
      _createElementVNode("button", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeft))
          ]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "返回", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Files))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hero-tag" }, "SHIP PROTOCOL · 运营协议管理", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "hero-title" }, "船舶运营协议管理", -1)),
          (currentShipName.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 目标船舶：" + _toDisplayString(currentShipName.value), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(DataLine))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-mini-label" }, "协议项总数", -1)),
          _createElementVNode("div", _hoisted_11, _toDisplayString(tableData.value.length), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Histogram))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-mini-label" }, "完整度", -1)),
          _createElementVNode("div", _hoisted_15, _toDisplayString(Math.round(completionRate.value * 100)) + "% ", 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", {
            class: "stat-mini-bar-fill",
            style: _normalizeStyle({ width: completionRate.value * 100 + '%' })
          }, null, 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(MagicStick))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-mini-label" }, "已配置组", -1)),
          _createElementVNode("div", _hoisted_20, _toDisplayString(groupsCompleted.value) + " / 3", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Filter))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-mini-label" }, "未保存修改", -1)),
          _createElementVNode("div", _hoisted_24, _toDisplayString(dirtyCount.value), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_input, {
            modelValue: searchKeyword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchKeyword).value = $event)),
            placeholder: "搜索字段名、数据名称或数据格式...",
            clearable: "",
            "prefix-icon": _unref(Search),
            size: "default"
          }, null, 8, ["modelValue", "prefix-icon"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_button, {
            icon: _unref(Refresh),
            class: "btn-tool",
            onClick: loadData
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" 刷新 ", -1)
            ]))]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_upload, {
            accept: ".xlsx",
            "auto-upload": false,
            "show-file-list": false,
            "on-change": handleImportExcel
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Upload),
                class: "btn-tool btn-warning"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode(" 导入 Excel ", -1)
                ]))]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            icon: _unref(Download),
            class: "btn-tool btn-primary",
            onClick: handleExportExcel
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode(" 导出 Excel ", -1)
            ]))]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            icon: _unref(Check),
            class: "btn-tool btn-primary",
            disabled: !isDirty.value,
            onClick: handleSaveAll
          }, {
            default: _withCtx(() => [
              _cache[16] || (_cache[16] = _createTextVNode(" 保存全部 ", -1)),
              (isDirty.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(dirtyCount.value), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["icon", "disabled"]),
          _createVNode(_component_el_button, {
            icon: _unref(Promotion),
            class: "btn-tool btn-success",
            disabled: !selectedShipId.value,
            loading: pushLoading.value,
            onClick: handlePush
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode(" 推送到终端 ", -1)
            ]))]),
            _: 1
          }, 8, ["icon", "disabled", "loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_el_icon, { size: 22 }, {
              default: _withCtx(() => [
                _createVNode(_component_Cellphone)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "group-title" }, "船舶基础数据", -1)),
              _createVNode(_component_el_tag, {
                type: "primary",
                effect: "dark",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getGroupData(1, 19).length) + " 项 ", 1)
                ]),
                _: 1
              })
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "group-subtitle" }, " 序号 1-19 · 终端自身传感器数据（4G / GPS / GNSS） ", -1))
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Plus),
            size: "small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleAddItem(1, 19)))
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode(" 新增 ", -1)
            ]))]),
            _: 1
          }, 8, ["icon"])
        ]),
        _createVNode(_component_el_table, {
          data: getFilteredGroupData(1, 19),
          border: "",
          stripe: "",
          "empty-text": 
            searchKeyword.value ? '没有匹配的数据' : '暂无数据，点击「新增」添加'
          ,
          class: "protocol-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "数据序号",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataId,
                  "onUpdate:modelValue": ($event: any) => ((row.dataId) = $event),
                  modelModifiers: { number: true },
                  type: "number",
                  size: "small",
                  class: _normalizeClass({
                  'data-id-input': true,
                  'cell-dirty': isFieldDirty(row, 'dataId', row.dataId),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "字段名称",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.fieldName,
                  "onUpdate:modelValue": ($event: any) => ((row.fieldName) = $event),
                  placeholder: "驼峰命名，如 gprsRssi",
                  size: "small",
                  class: _normalizeClass({
                  'has-error': !isValidFieldName(row.fieldName),
                  'cell-dirty': isFieldDirty(row, 'fieldName', row.fieldName),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "字段简写",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.shortCode,
                  "onUpdate:modelValue": ($event: any) => ((row.shortCode) = $event),
                  placeholder: "如 g1/b2/c3",
                  size: "small",
                  class: _normalizeClass({
                  'has-error': !isValidShortCode(row.shortCode),
                  'cell-dirty': isFieldDirty(row, 'shortCode', row.shortCode),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据名称",
              "min-width": "160"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataName,
                  "onUpdate:modelValue": ($event: any) => ((row.dataName) = $event),
                  placeholder: "中文描述",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataName', row.dataName),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据格式",
              "min-width": "180"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataFormat,
                  "onUpdate:modelValue": ($event: any) => ((row.dataFormat) = $event),
                  placeholder: "如 I::%:DATA",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataFormat', row.dataFormat),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据来源",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataSource,
                  "onUpdate:modelValue": ($event: any) => ((row.dataSource) = $event),
                  placeholder: "如 电池域?:x3",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataSource', row.dataSource),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据说明",
              "min-width": "180"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.description,
                  "onUpdate:modelValue": ($event: any) => ((row.description) = $event),
                  placeholder: "说明",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(
                    row,
                    'description',
                    row.description
                  ),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "70",
              align: "center",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                (isDefaultData(row) && canRestore(row))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: "恢复默认",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          icon: _unref(RefreshLeft),
                          size: "small",
                          circle: "",
                          onClick: ($event: any) => (handleRestore(row))
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : (!isDefaultData(row))
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        content: "删除",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            icon: _unref(Delete),
                            size: "small",
                            circle: "",
                            onClick: ($event: any) => (handleDelete(row))
                          }, null, 8, ["icon", "onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "empty-text"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_el_icon, { size: 22 }, {
              default: _withCtx(() => [
                _createVNode(_component_Lightning)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "group-title" }, "电池运营数据", -1)),
              _createVNode(_component_el_tag, {
                type: "warning",
                effect: "dark",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getGroupData(20, 99).length) + " 项 ", 1)
                ]),
                _: 1
              })
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "group-subtitle" }, " 序号 20-99 · 电池能耗 / SOC / 工况等数据 ", -1))
          ]),
          _createVNode(_component_el_button, {
            type: "warning",
            icon: _unref(Plus),
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleAddItem(20, 99)))
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode(" 新增 ", -1)
            ]))]),
            _: 1
          }, 8, ["icon"])
        ]),
        _createVNode(_component_el_table, {
          data: getFilteredGroupData(20, 99),
          border: "",
          stripe: "",
          "empty-text": 
            searchKeyword.value ? '没有匹配的数据' : '暂无数据，点击「新增」添加'
          ,
          class: "protocol-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "数据序号",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataId,
                  "onUpdate:modelValue": ($event: any) => ((row.dataId) = $event),
                  modelModifiers: { number: true },
                  type: "number",
                  size: "small",
                  class: _normalizeClass({
                  'data-id-input': true,
                  'cell-dirty': isFieldDirty(row, 'dataId', row.dataId),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "字段名称",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.fieldName,
                  "onUpdate:modelValue": ($event: any) => ((row.fieldName) = $event),
                  placeholder: "驼峰命名，如 gprsRssi",
                  size: "small",
                  class: _normalizeClass({
                  'has-error': !isValidFieldName(row.fieldName),
                  'cell-dirty': isFieldDirty(row, 'fieldName', row.fieldName),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "字段简写",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.shortCode,
                  "onUpdate:modelValue": ($event: any) => ((row.shortCode) = $event),
                  placeholder: "如 g1/b2/c3",
                  size: "small",
                  class: _normalizeClass({
                  'has-error': !isValidShortCode(row.shortCode),
                  'cell-dirty': isFieldDirty(row, 'shortCode', row.shortCode),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据名称",
              "min-width": "160"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataName,
                  "onUpdate:modelValue": ($event: any) => ((row.dataName) = $event),
                  placeholder: "中文描述",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataName', row.dataName),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据格式",
              "min-width": "180"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataFormat,
                  "onUpdate:modelValue": ($event: any) => ((row.dataFormat) = $event),
                  placeholder: "如 I::%:DATA",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataFormat', row.dataFormat),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据来源",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataSource,
                  "onUpdate:modelValue": ($event: any) => ((row.dataSource) = $event),
                  placeholder: "如 电池域?:x3",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataSource', row.dataSource),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据说明",
              "min-width": "180"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.description,
                  "onUpdate:modelValue": ($event: any) => ((row.description) = $event),
                  placeholder: "说明",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(
                    row,
                    'description',
                    row.description
                  ),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "70",
              align: "center",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                (isDefaultData(row) && canRestore(row))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: "恢复默认",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          icon: _unref(RefreshLeft),
                          size: "small",
                          circle: "",
                          onClick: ($event: any) => (handleRestore(row))
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : (!isDefaultData(row))
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        content: "删除",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            icon: _unref(Delete),
                            size: "small",
                            circle: "",
                            onClick: ($event: any) => (handleDelete(row))
                          }, null, 8, ["icon", "onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "empty-text"])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_el_icon, { size: 22 }, {
              default: _withCtx(() => [
                _createVNode(_component_TrendCharts)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "group-title" }, "船舶运营数据", -1)),
              _createVNode(_component_el_tag, {
                type: "success",
                effect: "dark",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getGroupData(100, 999).length) + " 项 ", 1)
                ]),
                _: 1
              })
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "group-subtitle" }, " 序号 101-111 · 船舶综合数据（供 CCS 报送） ", -1))
          ]),
          _createVNode(_component_el_button, {
            type: "success",
            icon: _unref(Plus),
            size: "small",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleAddItem(100, 999)))
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" 新增 ", -1)
            ]))]),
            _: 1
          }, 8, ["icon"])
        ]),
        _createVNode(_component_el_table, {
          data: getFilteredGroupData(100, 999),
          border: "",
          stripe: "",
          "empty-text": 
            searchKeyword.value ? '没有匹配的数据' : '暂无数据，点击「新增」添加'
          ,
          class: "protocol-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "数据序号",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataId,
                  "onUpdate:modelValue": ($event: any) => ((row.dataId) = $event),
                  modelModifiers: { number: true },
                  type: "number",
                  size: "small",
                  class: "data-id-input"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "字段名称",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.fieldName,
                  "onUpdate:modelValue": ($event: any) => ((row.fieldName) = $event),
                  placeholder: "驼峰命名，如 gprsRssi",
                  size: "small",
                  class: _normalizeClass({
                  'has-error': !isValidFieldName(row.fieldName),
                  'cell-dirty': isFieldDirty(row, 'fieldName', row.fieldName),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "字段简写",
              "min-width": "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.shortCode,
                  "onUpdate:modelValue": ($event: any) => ((row.shortCode) = $event),
                  placeholder: "如 g1/b2/c3",
                  size: "small",
                  class: _normalizeClass({
                  'has-error': !isValidShortCode(row.shortCode),
                  'cell-dirty': isFieldDirty(row, 'shortCode', row.shortCode),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据名称",
              "min-width": "160"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataName,
                  "onUpdate:modelValue": ($event: any) => ((row.dataName) = $event),
                  placeholder: "中文描述",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataName', row.dataName),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据格式",
              "min-width": "180"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataFormat,
                  "onUpdate:modelValue": ($event: any) => ((row.dataFormat) = $event),
                  placeholder: "如 D:6:deg:DATA",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataFormat', row.dataFormat),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据来源",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.dataSource,
                  "onUpdate:modelValue": ($event: any) => ((row.dataSource) = $event),
                  placeholder: "空字符串",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(row, 'dataSource', row.dataSource),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数据说明",
              "min-width": "180"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.description,
                  "onUpdate:modelValue": ($event: any) => ((row.description) = $event),
                  placeholder: "说明",
                  size: "small",
                  class: _normalizeClass({
                  'cell-dirty': isFieldDirty(
                    row,
                    'description',
                    row.description
                  ),
                })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "70",
              align: "center",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                (isDefaultData(row) && canRestore(row))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: "恢复默认",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          icon: _unref(RefreshLeft),
                          size: "small",
                          circle: "",
                          onClick: ($event: any) => (handleRestore(row))
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : (!isDefaultData(row))
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        content: "删除",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            icon: _unref(Delete),
                            size: "small",
                            circle: "",
                            onClick: ($event: any) => (handleDelete(row))
                          }, null, 8, ["icon", "onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "empty-text"])
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "bottom-spacer" }, null, -1))
    ])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})